(() => {
  const cs = document.currentScript;
  let sid = null;
  try { sid = new URL(cs.src).searchParams.get('sid'); } catch (e) {}
  const root = sid ? document.getElementById(`pcc-${sid}`) : null;
  if (!root) return;

  const videos = [...root.querySelectorAll('.pcc__video-frame video.pcc__video')];
  if (!videos.length) return;
// helper: Button erstellen
const addUnmuteBtn = (frame, video) => {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pcc__unmute';
  btn.setAttribute('aria-label','Ton einschalten');
  btn.innerHTML = '🔈';
  frame.appendChild(btn);

  const sync = () => btn.classList.toggle('is-hidden', !video.muted);
  sync();

  btn.addEventListener('click', () => {
    video.muted = !video.muted;
    if (!video.muted) video.play().catch(()=>{});
    sync();
  });

  // Wenn Browser z.B. Autoplay verhindert und Tonzustand ändert
  video.addEventListener('volumechange', sync);
};

// ... später in videos.forEach(v => { ... })
videos.forEach(v => {
  // bestehend:
  if (v.readyState >= 1) setAR(v);
  else v.addEventListener('loadedmetadata', () => setAR(v), { once: true });

  v.muted = true; v.playsInline = true; v.loop = true;
  v.addEventListener('loadeddata', () => setAR(v));

  // NEU: Button hinzufügen
  const frame = v.closest('.pcc__video-frame');
  if (frame) addUnmuteBtn(frame, v);
});

  // Ratio & Fit setzen – unterstützt data-orientation: portrait | landscape | auto
  const setAR = v => {
    const frame = v.closest('.pcc__video-frame');
    if (!frame) return;

    const req = (frame.dataset.orientation || 'auto').toLowerCase();
    const w = v.videoWidth || 16, h = v.videoHeight || 9;
    const isPortraitSrc = h > w;

    if (req === 'portrait') {
      // <-- Das ist der Zweig, den du suchst
      frame.style.setProperty('--pcc-v-ar', `9 / 16`);
      v.dataset.fit = 'cover'; // immer vollflächig in 9:16, ggf. seitlicher Crop
      return;
    }

    if (req === 'landscape') {
      frame.style.setProperty('--pcc-v-ar', `16 / 9`);
      v.dataset.fit = 'cover';
      return;
    }

    // auto → echte Quellen-Ratio nehmen
    frame.style.setProperty('--pcc-v-ar', `${w} / ${h}`);
    v.dataset.fit = 'cover';
  };

  videos.forEach(v => {
    if (v.readyState >= 1) setAR(v);
    else v.addEventListener('loadedmetadata', () => setAR(v), { once: true });

    // Autoplay/Loop robust setzen
    v.muted = true;
    v.playsInline = true;
    v.loop = true;

    v.addEventListener('loadeddata', () => setAR(v));
  });

  // Autoplay on view (~50%), Pause off view
  const io = new IntersectionObserver(entries => {
    entries.forEach(({ target, intersectionRatio }) => {
      if (intersectionRatio >= 0.5) {
        target.play().catch(() => {});
      } else {
        target.pause();
      }
    });
  }, { threshold: [0, 0.3] });

  videos.forEach(v => io.observe(v));

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(v => v.pause());
  });
})();
